import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { RISK_SUMMARY_REPORT_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'
import '../Custom.css'

const RISK_SUMMARY_REPORT = gql(RISK_SUMMARY_REPORT_QUERY)

export default function RiskSummaryReport({ location }) {
  console.log('RiskSummaryReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, RISK_SUMMARY_REPORT, 'riskSummary', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0)
    console.log(resultRows)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/riskSummary/risk_summary')} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Risk Summary Report'} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}